import { isCruiseOnlyOfferView, type CruiseOfferView } from 'hooks/Cruise/useCruiseOfferView'
import { isDisplayablePrice } from 'lib/offer/pricingVisibility'
import CruiseOverviewSinglePrice from './CruiseOverviewSinglePrice'
import CruiseOverviewBundlePrice from './CruiseOverviewBundlePrice'

interface Props {
  view: CruiseOfferView
  hasValidDepartureDates: boolean
  showPackageOptions: () => void
}

function CruiseOverviewPrice({ view, hasValidDepartureDates, showPackageOptions }: Props) {
  if (!isCruiseOnlyOfferView(view)) return null

  const bundlePrice = view.lowestBundlePrice?.promotionalPrice?.total ?? view.lowestBundlePrice?.primaryPrice.total
  if (hasValidDepartureDates && isDisplayablePrice(bundlePrice)) {
    return <CruiseOverviewBundlePrice
      view={view}
      hasValidDepartureDates={hasValidDepartureDates}
      showPackageOptions={showPackageOptions}
    />
  }

  return <CruiseOverviewSinglePrice
    view={view}
    hasValidDepartureDates={hasValidDepartureDates}
    showPackageOptions={showPackageOptions}
  />
}

export default CruiseOverviewPrice
